import { WHITE, RED, BLUE, GREEN, ORANGE, YELLOW } from "./../colors";
import { PIECE_TYPE } from "./enum";
import { Vector3 } from "../../math/vector";
export const ROTATION_VECTOR = Vector3.fromValues(0.92875, -0.24803, 0);
export const TOP_COLOR = YELLOW;
export const BOTTOM_COLOR = WHITE;
export const FRONT_COLOR = RED;
export const LEFT_COLOR = BLUE;
export const RIGHT_COLOR = GREEN;
export const BACK_COLOR = ORANGE;
export const DEFAULT_SQ1_SCHEME = {
    top: TOP_COLOR,
    front: FRONT_COLOR,
    bottom: BOTTOM_COLOR,
    left: LEFT_COLOR,
    right: RIGHT_COLOR,
    back: BACK_COLOR,
};
export const SOLVED_TOP_PIECES = [
    { type: PIECE_TYPE.CORNER, colors: [TOP_COLOR, FRONT_COLOR, LEFT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [TOP_COLOR, LEFT_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [TOP_COLOR, LEFT_COLOR, BACK_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [TOP_COLOR, BACK_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [TOP_COLOR, BACK_COLOR, RIGHT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [TOP_COLOR, RIGHT_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [TOP_COLOR, RIGHT_COLOR, FRONT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [TOP_COLOR, FRONT_COLOR] },
];
export const SOLVED_BOTTOM_PIECES = [
    { type: PIECE_TYPE.EDGE, colors: [BOTTOM_COLOR, BACK_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [BOTTOM_COLOR, BACK_COLOR, LEFT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [BOTTOM_COLOR, LEFT_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [BOTTOM_COLOR, LEFT_COLOR, FRONT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [BOTTOM_COLOR, FRONT_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [BOTTOM_COLOR, FRONT_COLOR, RIGHT_COLOR] },
    { type: PIECE_TYPE.EDGE, colors: [BOTTOM_COLOR, RIGHT_COLOR] },
    { type: PIECE_TYPE.CORNER, colors: [BOTTOM_COLOR, RIGHT_COLOR, BACK_COLOR] },
];
